import React, {PureComponent} from 'react';

interface IInventorySearchBarState {}

export class InventorySearchBar extends PureComponent<any, IInventorySearchBarState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <div className="bar-position">
                <h2 className='text-light'>
                    Laoseis
                </h2>
                <div className="card mb-5">
                    <div className="card-body">
                        <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row'>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
